import get from 'lodash/get';
import { statesLookup } from './config';

export const getStateCodeFromStateName = (stateName) => get(statesLookup, stateName);
